import { render } from "./_item.vue?vue&type=template&id=31f192fa&lang=pug"
import script from "./_item.vue?vue&type=script&lang=js"
export * from "./_item.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__